import {
  Popper,
  ClickAwayListener,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Switch,
  Chip,
  Box,
  IconButton,
  useTheme,
  Badge,
  styled,
  Stack,
} from '@mui/material';
import { ReactComponent as LogoutIcon } from '../assets/images/settings_signout.svg';
import { ReactComponent as SettingsIcon } from '../assets/images/settings_account_setting.svg';
import { ReactComponent as GiftIcon } from '../assets/images/settings_referral.svg';
import { ReactComponent as PricingIcon } from '../assets/images/settings_pricing.svg';
import { ReactComponent as InstagramIcon } from '../assets/images/settings_instagram.svg';
import { ReactComponent as HelpIcon } from '../assets/images/settings_help.svg';
import { ReactComponent as FaqIcon } from '../assets/images/settings_faq.svg';
import { ReactComponent as TermsIcon } from '../assets/images/settings_terms.svg';
import { ReactComponent as InfoIcon } from '../assets/images/settings_about.svg';
import { ReactComponent as LaptopIcon } from '../assets/images/settings_system_theme.svg';
import { ReactComponent as LightModeIcon } from '../assets/images/settings_light_theme.svg';
import { ReactComponent as DarkModeIcon } from '../assets/images/settings_dark_theme.svg';
import { ReactComponent as LaptopSelectedIcon } from '../assets/images/settings_system_theme_selected.svg';
import { ReactComponent as LightModeSelectedIcon } from '../assets/images/settings_light_theme_selected.svg';
import { ReactComponent as DarkModeSelectedIcon } from '../assets/images/settings_dark_theme_selected.svg';
import { ReactComponent as OpenInNewIcon } from '../assets/images/settings_opennew.svg';

export default function SettingsMenu({
  showSettings,
  settingsAnchor,
  isMobile,
  handleCloseSettings,
  navigate,
  darkMode,
  handleDarkModeClick,
  selectedMode,
  handleLogout,
  email,
}) {
  const theme = useTheme();
  return (
    <Popper
      open={showSettings}
      anchorEl={settingsAnchor}
      placement={isMobile ? 'top-end' : 'bottom-start'}
      disablePortal={false}
      sx={{
        zIndex: 1400,
        [theme.breakpoints.down('sm')]: {
          position: 'fixed !important',
          width: '95vw !important',
          top: '60px !important',
          left: '2.5vw !important',
          right: 'auto !important',
          transform: 'none !important',
        },
      }}
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 4], // [horizontal, vertical] → pushes it 8px below
          },
        },
      ]}
    >
      <ClickAwayListener onClickAway={handleCloseSettings}>
        <Paper
          elevation={0}
          sx={{
            mt: 1,
            display: 'flex',
            width: { xs: '90vw', sm: 268, md: 268, lg: 268 },
            flex: '0 0 auto',
            flexDirection: 'column',
            // minHeight: { xs: 'auto', sm: 400, md: 400, lg: 613 },
            maxHeight: 'calc(100dvh - 80px)',
            borderRadius: '8px',
            border: '1px solid #bababa',
            overflowY: 'auto',
            bgcolor: 'background.default',
            fontSize: { xs: '14px', sm: '14px', md: '14px', lg: '14px' },
            fontWeight: 500,
            color:
              theme.palette.mode === 'dark'
                ? '#BABABA !important'
                : '#454545CC !important',
          }}
        >
          <Box py={2} px={2}>
            <Typography variant="h5" fontWeight={500} sx={{ color: 'inherit' }}>
              {email}
            </Typography>
          </Box>
          <Divider sx={{ my: 0, mx: 2 }} />

          <List disablePadding>
            <ListItem
              button
              onClick={() => navigate('/my-settings')}
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <SettingsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    Birth Time Settings
                  </Typography>
                }
              />
            </ListItem>

            <ListItem
              button
              onClick={() => navigate('/home/Community_&_Impact/My_Referral')}
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <GiftIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    My referrals
                  </Typography>
                }
              />
              <NormalBadge color="primary" badgeContent="Upcoming" />
            </ListItem>

            <ListItem
              button
              onClick={() => navigate('/pricing')}
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <PricingIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    Pricing
                  </Typography>
                }
              />
              <GradientBadge color="primary" badgeContent="View" />
            </ListItem>

            <ListItem
              button
              onClick={() =>
                window.open('https://www.instagram.com/kaliyug_ai', '_blank')
              }
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <InstagramIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    Instagram
                  </Typography>
                }
              />
              <IconButton edge="end" size="small">
                <OpenInNewIcon fontSize="inherit" />
              </IconButton>
            </ListItem>

            <ListItem
              button
              onClick={() => navigate('/home/Company/Contact')}
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <HelpIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    Help Centre
                  </Typography>
                }
              />
              <IconButton edge="end" size="small">
                <OpenInNewIcon fontSize="inherit" />
              </IconButton>
            </ListItem>
          </List>

          <Divider sx={{ my: { xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5 }, mx: 2 }} />

          <Box px={2}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontSize: { xs: 10, sm: 10, md: '10px', lg: '12px' },
                mt: { sm: 1, md: 1, lg: 1.5 },
                py: { xs: 0.5, sm: 0.5, md: 0, lg: 0 },
                mb: { md: 0.5, lg: 0.5 },
                color: '#909090',
              }}
            >
              Preferences
            </Typography>
          </Box>

          <List disablePadding>
            <ListItem
              sx={{
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    Theme
                  </Typography>
                }
              />
              <Stack
                direction="row"
                spacing={{ xs: 0, sm: 0, md: 0.5, lg: 0.5 }}
              >
                <IconButton
                  size="small"
                  sx={{
                    '&:hover': {
                      bgcolor:
                        selectedMode === 'system'
                          ? 'action.hover'
                          : 'action.hover',
                      borderRadius: '4px',
                    },
                  }}
                  onClick={() => handleDarkModeClick('system')}
                >
                  {selectedMode === 'system' ? (
                    <LaptopSelectedIcon fontSize="small" />
                  ) : (
                    <LaptopIcon fontSize="small" />
                  )}
                </IconButton>
                <IconButton
                  size="small"
                  sx={{
                    '&:hover': {
                      bgcolor:
                        selectedMode === 'light'
                          ? 'action.hover'
                          : 'action.hover',
                      borderRadius: '4px',
                    },
                  }}
                  onClick={() => handleDarkModeClick('light')}
                >
                  {selectedMode === 'light' ? (
                    <LightModeSelectedIcon fontSize="small" />
                  ) : (
                    <LightModeIcon fontSize="small" />
                  )}
                </IconButton>
                <IconButton
                  size="small"
                  sx={{
                    '&:hover': {
                      bgcolor:
                        selectedMode === 'dark'
                          ? 'action.hover'
                          : 'action.hover',
                      borderRadius: '4px',
                    },
                  }}
                  onClick={() => handleDarkModeClick('dark')}
                >
                  {selectedMode === 'dark' ? (
                    <DarkModeSelectedIcon fontSize="small" />
                  ) : (
                    <DarkModeIcon fontSize="small" />
                  )}
                </IconButton>
              </Stack>
            </ListItem>

            <ListItem
              sx={{
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    Language
                  </Typography>
                }
              />
              <LanguageBadge color="primary" badgeContent="English" />
            </ListItem>

            <ListItem
              button
              onClick={() => navigate('/what-to-ask')}
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <FaqIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    FAQ
                  </Typography>
                }
              />
            </ListItem>

            <ListItem
              button
              onClick={() => navigate('/home/Company/Terms_of_Service')}
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <TermsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    Terms
                  </Typography>
                }
              />
            </ListItem>

            <ListItem
              button
              onClick={() => navigate('/home/Company/About_us')}
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <InfoIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    About
                  </Typography>
                }
              />
            </ListItem>
          </List>

          <Divider sx={{ my: { xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5 }, mx: 2 }} />

          <List disablePadding>
            <ListItem
              button
              onClick={handleLogout}
              sx={{
                cursor: 'pointer',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                py: { xs: '6px', sm: '6px', md: '6px', lg: '8px' },
              }}
            >
              <ListItemIcon sx={{ mr: '10px', minWidth: '24px' }}>
                <LogoutIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ color: 'inherit' }}
                    variant="h5"
                    fontWeight={500}
                  >
                    Sign Out
                  </Typography>
                }
              />
            </ListItem>
          </List>

          <Box
            width={'100%'}
            pt={0}
            mt={0}
            textAlign="right"
            sx={{
              paddingRight: 2,
              paddingBottom: { xs: 0, sm: 0, md: 0.5, lg: 1 },
            }}
          >
            <Typography
              sx={{ color: 'inherit' }}
              variant="caption"
              fontSize={10}
              textAlign={'right'}
            >
              Version 1.0s
            </Typography>
          </Box>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}

const GradientBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    background: 'linear-gradient(to right, #FF934F, #FED043)',
    color: '#fff',
    cursor: 'pointer',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    marginRight: '40px',
    width: '77px',
  },
}));

const NormalBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    background: '#BFBDBD99',
    color: '#fff',
    cursor: 'pointer',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    marginRight: '40px',
    width: '77px',
  },
}));

const LanguageBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    background: '#E5E5E5',
    color: '#454545CC',
    cursor: 'pointer',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    marginRight: '40px',
    width: '77px',
  },
}));
